import { RESET_STEP2_VALIDATION } from "../types";

export const updateValidationStatus = (type, valid) => (dispatch) => {
  dispatch({
    type: type,
    payload: valid,
  });
};

export const resetStep2Validation = () => (dispatch) => {
  dispatch({
    type: RESET_STEP2_VALIDATION,
  });
};



// WEBPACK FOOTER //
// ./src/actions/ValidationActions/validateStep2Acitons.js